<template>
  <DetailsContentPane>
    <TransportationButtonSection class="mb-2" />
    <DetailsTransportationFlight v-if="flight" />
    <DetailsTransportationFlexFlight v-if="flexFlight" />
    <DetailsTransportationRail v-if="rail" />
    <DetailsTransportationIndividual v-if="individual" />
  </DetailsContentPane>
</template>

<script lang="ts">
import { useDetailsStore } from '@/store';
import { mapState } from 'pinia';
import { defineComponent } from 'vue';
import DetailsContentPane from '../DetailsContentPane.vue';
import DetailsTransportationFlexFlight from './DetailsTransportationFlexFlight.vue';
import DetailsTransportationFlight from './DetailsTransportationFlight.vue';
import DetailsTransportationIndividual from './DetailsTransportationIndividual.vue';
import DetailsTransportationRail from './DetailsTransportationRail.vue';
import TransportationButtonSection from './TransportationButtonSection.vue';

export default defineComponent({
  components: {
    DetailsContentPane,
    TransportationButtonSection,
    DetailsTransportationFlight,
    DetailsTransportationIndividual,
    DetailsTransportationFlexFlight,
    DetailsTransportationRail
},

  computed: {
    ...mapState(useDetailsStore, {
      transportation: store => store.transportation
    }),
    flight() {
      return this.transportation === 'Flug';
    },
    flexFlight() {
      return this.transportation === 'Wunschflug';
    },
    rail() {
      return this.transportation === 'Bahn';
    },
    individual() {
      return this.transportation === 'Individuell';
    }
  }
})
</script>

<style lang="scss" scoped>
</style>
